import {
  type EssentialResellersData,
  GET_ESSENTIAL_RESELLERS_DATA,
} from 'components/form/select/queries/getEssentialResellersData';
import { Select, Skeleton } from 'antd';
import type { SelectProps } from 'antd/lib/select';
import type { VFC } from 'react';
import { useAppNotifications } from 'hooks';
import { useStrapiQuery } from 'hooks/useStrapiQuery';
import { filterOption, filterSort } from '../utils';

export interface ResellersSelectProps extends SelectProps<number> {
  onChange?: (value: [number] | number | null) => void;
}

export const ResellersSelect: VFC<ResellersSelectProps> = ({ onChange, ...propsToPass }) => {
  const notify = useAppNotifications();

  const { data: { resellers: { data: resellers = [] } = {} } = {}, loading: isLoadingResellers } = useStrapiQuery<
    EssentialResellersData,
    undefined
  >(GET_ESSENTIAL_RESELLERS_DATA, {
    onError(error) {
      notify.error({
        message: `Error while fetching resellers. Please try again.`,
        description: error instanceof Error ? error.message : undefined,
      });
    },
    fetchPolicy: 'cache-and-network',
  });

  return isLoadingResellers ? (
    <Skeleton.Input active block />
  ) : (
    <Select
      allowClear
      showSearch
      filterOption={filterOption}
      filterSort={filterSort}
      loading={isLoadingResellers}
      options={resellers
        .filter(reseller => !!reseller.enmon_customer_id)
        .map(reseller => ({
          label: reseller.name,
          value: reseller.enmon_customer_id,
        }))}
      style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
      onClear={() => onChange?.(null)}
      onSelect={(id?: number) => onChange?.(id)}
      {...propsToPass}
    />
  );
};
